import { useEffect, useState } from 'react'
import { getPDFOc } from "../../Fetch/GetPDF";
import { useParams } from "react-router";
import Loading from "../Loading/Loading";
import './pdfcot.css'

export default function Pdf_Oc() {
    let params = useParams();
    const [pdfData, setPdfData] = useState({ valid: false, data: [], Loading: false });

    useEffect(() => {
        getPDFOc(params.hash).then(res => {
            if (res.valid) {
                if (res.payload.length > 0) {
                    document.getElementById('Tit').innerText = 'Orden-' + res.payload[0].name;

                    setPdfData(v => (
                        {
                            ...v,
                            Loading: true,
                            valid: res.valid,
                            data: res.payload.map((d, i) => (
                                {
                                    ...d.pdf,
                                    pdf: 'data:application/pdf;base64,' + d.pdf
                                }
                            ))
                        }))
                }
            } else {
                setPdfData(v => (
                    {
                        ...v,
                        Loading: true,
                        valid: res.valid,
                        data: res.payload.map((d, i) => (
                            {
                                ...d.pdf,
                                pdf: 'data:application/pdf;base64,' + d.pdf
                            }
                        ))
                    }))
            }
        })
    }, [setPdfData, params])

    return (

        pdfData.Loading ?
            pdfData.data.length > 0 ?
                pdfData.data.map((dpdf, ipdf) => (
                    <div className='PDFCot' key={ipdf} >
                        <object data={`${dpdf.pdf}#toolbar=0`}>ObjetoPDF</object>
                    </div>
                )) :
                <span>PDF no encontrado</span>
            :
            <Loading />
    )
}